/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_TotalInputs */

const vi_customer_display_total = /** @type {(inputs: Customer_Display_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng cộng`)
};

/**

* @param {Customer_Display_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_total = /** @type {((inputs?: Customer_Display_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_total(inputs)
});